import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SUPPORT } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { NATIVE_BUILDS_FAQS } from '../../constants';

@Component({
  selector: 'app-native-builds-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './native-builds-faq-section.component.html',
  styleUrl: './native-builds-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly items = NATIVE_BUILDS_FAQS;
}
